import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getInfoCabecalho } from "../Adesao/action";
import { buscarCuidadores } from "../Urgencia/action";
import { Row, Col } from "antd";
import { useParams, Navigate } from "react-router-dom";
import BarraInformacao from "../../Components/BarraInformacao";
import BarLoader from "react-spinners/BarLoader";
import OpcoesRotina from "../Rotina/OpcoesRotina";
import TabelaDesvio from "./Components/TabelaDesvio";
import "./style.scss";

const DesvioPadrao = (props) => {
  const { tarefa, tipo } = useParams();

  useEffect(() => {
    if (props.paciente) {
      props.buscarCuidadores(props.paciente);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.paciente]);

  useEffect(() => {
    props.getInfoCabecalho(props.user.id, tarefa, tipo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tarefa]);

  return (
    <>
      {!tarefa && <Navigate to="/" replace />}
      <BarraInformacao />
      {!props.loading ? (
        <Row className={"layout-rotina"}>
          <Col className={"coluna-folloup"}>
            <TabelaDesvio />
          </Col>
          <Col className={"coluna-body"}>
            <OpcoesRotina />
          </Col>
        </Row>
      ) : (
        <BarLoader color={"#0F79B2"} width={"100vw"} />
      )}
    </>
  );
};

const mapStateToProps = (store) => ({
  paciente: store.adesao.paciente,
  loading: store.barrainformacao.loading,
  user: store.login.user,
});

const mapDispatchToProps = (dispatch) => ({
  getInfoCabecalho: (enfermeiroID, tarefaID, tipo) =>
    dispatch(getInfoCabecalho(enfermeiroID, tarefaID, tipo)),
  buscarCuidadores: (paciente) => dispatch(buscarCuidadores(paciente)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DesvioPadrao);
